var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChartLine = function SvgChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.313 3.656v9.625c0 .383.273.656.656.656h11.375c.355 0 .656.301.656.657 0 .383-.3.656-.656.656H3.969A1.96 1.96 0 0 1 2 13.281V3.656C2 3.301 2.273 3 2.656 3c.356 0 .656.3.656.656Zm11.62 3.09-3.745 3.719a.599.599 0 0 1-.903 0l-2.16-2.16-2.16 2.16c-.274.273-.684.273-.93 0a.599.599 0 0 1 0-.902L7.66 6.937c.11-.136.274-.19.465-.19a.64.64 0 0 1 .465.19l2.16 2.16 3.254-3.253c.246-.274.656-.274.93 0a.644.644 0 0 1 0 .902Z"
  })));
};
export default SvgChartLine;